import { createSelector } from 'reselect';

import { IApplicationState } from '../../types/redux';
import { IPromo } from '../../types/developer/promos';
import { getFskPromoUrl } from '../../utils/getFskPromoUrl';

const emptyPromos: IPromo[] = [];

const getFskPromoSlider = (state: IApplicationState) => state.fsk?.promoSlider;
const getDeveloperState = (state: IApplicationState) => state.developer;

export const getPromos = createSelector(
  [getFskPromoSlider, getDeveloperState],
  (fskPromoSlider, developer): IPromo[] => {
    if (fskPromoSlider) {
      return fskPromoSlider.map((promo, index) => {
        const hasCallbackPopup = Boolean(promo.hasCallbackPopup);

        return {
          image: promo.image,
          newbuildingId: index,
          url: getFskPromoUrl({ isEmpty: hasCallbackPopup, hitUrl: promo.hitUrl || '', erid: promo.erid }),
          erId: promo.erid,
          hasCallbackPopup,
          disclaimer: promo.disclaimer,
        };
      });
    }

    if (!developer) {
      return emptyPromos;
    }

    return developer.promos.map(promo => ({
      ...promo,
      hasCallbackPopup: promo.newbuildingId === 0,
    }));
  },
);
